// hooks/useBulkActions.js
import { deleteProduct, updateProduct } from "../../../../../firebase/product-functions";
import { removeFromSales } from "../../../../../firebase/sales-functions";
import { DEFAULT_STORE_ID } from '../../../../../firebase/firebase';
export const useBulkActions = ({
    products,
    setProducts,
    selectedProducts,
    setSelectedProducts,
    salesItems,
    getProductDiscount,
    setLoading,
    setError,
    setSelectedProductForDiscount,
    setShowDiscountModal
}) => {
    const handleBulkAction = async (action) => {
        if (selectedProducts.length === 0) {
            alert("Please select at least one product.");
            return;
        }

        try {
            setLoading(true);

            switch (action) {
                case "delete":
                    await handleBulkDelete();
                    break;

                case "active":
                    await handleBulkStatusUpdate("active");
                    break;

                case "inactive":
                    await handleBulkStatusUpdate("inactive");
                    break;

                case "bulk-discount":
                    setSelectedProductForDiscount("bulk");
                    setShowDiscountModal(true);
                    break;

                default:
                    break;
            }
        } catch (error) {
            console.error("Error performing bulk action:", error);
            setError("Failed to perform action. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleBulkDelete = async () => {
        if (window.confirm(`Are you sure you want to delete ${selectedProducts.length} products?`)) {
            for (const productId of selectedProducts) {
                await deleteProduct(DEFAULT_STORE_ID, productId);
                // Also remove from sales if exists
                const discount = getProductDiscount(productId);
                if (discount) {
                    await removeFromSales(DEFAULT_STORE_ID, discount.id);
                }
            }
            setProducts(products.filter(product => !selectedProducts.includes(product.id)));
            setSelectedProducts([]);
        }
    };

    const handleBulkStatusUpdate = async (status) => {
        for (const productId of selectedProducts) {
            await updateProduct(DEFAULT_STORE_ID, productId, { status });
        }
        const updatedProducts = products.map(product =>
            selectedProducts.includes(product.id) ? { ...product, status } : product
        );
        setProducts(updatedProducts);
    };

    return { handleBulkAction };
};